/**
 * @file vuex
 * @author tianzhu(tianzhu@baidu.com)
 */

import Vue from 'vue';
import Vuex from 'vuex';
import app from './app';
import aicreate from '@/views/AiFrontPage/store/aicreate';
import imageCutout from './modules/imageCutout';
import imageCutoutV2 from './modules/imageCutoutV2';
import imageExpand from './modules/imageExpand';
import imageExpandV2 from './modules/imageExpandV2';
import imageFront from './modules/imageFront';
import helpDoc from '@/views/Docs/store/helpDoc';
import imageMarket from './modules/imageMarket';
import imageMarketV2 from './modules/imageMarketV2';
import feedback from './modules/feedback';
import imageStitching from './modules/imageStitching';
import imageStitchingV2 from './modules/imageStitchingV2';
import imageCrop from './modules/imageCrop';
import imageCoverPic from './modules/imageCoverPic';
import imageTemplate from './modules/imageTemplate';
import imageCropV2 from './modules/imageCropV2';
import imageBatchPic from './modules/imageBatchPic';
import message from './modules/message';
import cacheModule from './modules/cacheModule';
import textCreate from './modules/textCreate';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        app,
        aicreate,
        imageCutout,
        imageCutoutV2,
        imageExpand,
        imageExpandV2,
        imageFront,
        helpDoc,
        imageMarket,
        imageMarketV2,
        feedback,
        imageStitching,
        imageStitchingV2,
        imageCrop,
        imageCoverPic,
        imageTemplate,
        imageCropV2,
        imageBatchPic,
        message,
        textCreate,
        cacheModule
    }
});
